export const en = {
  // Navigation
  home: "Home",
  orders: "My Orders",
  profile: "Profile",
  
  // Auth
  login: "Login",
  register: "Register",
  phone: "Phone Number",
  email: "Email",
  fullName: "Full Name", 
  city: "City",
  continue: "Continue",
  guestMode: "Guest Mode",
  verifyOTP: "Verify Code",
  
  // Home
  currentLocation: "Current Location",
  startNewTrip: "Start New Trip",
  standardRequest: "Standard Request",
  biddingRequest: "Bidding Request",
  estimatedPrice: "Estimated Price",
  
  // Trip Types
  economy: "Economy",
  family: "Family",
  vip: "VIP",
  
  // Booking
  pickupLocation: "Pickup Location",
  destination: "Destination",
  vehicleType: "Vehicle Type",
  confirmRequest: "Confirm Request",
  
  // Bidding
  biddingDescription: "Your request will be sent to all available drivers for price offers",
  waitingForOffers: "Waiting for Offers",
  driverName: "Driver Name",
  suggestedPrice: "Suggested Price",
  rating: "Rating",
  selectOffer: "Select Offer",
  
  // Tracking
  driverOnWay: "Driver on Way",
  tripInProgress: "Trip in Progress",
  tripCompleted: "Trip Completed",
  callDriver: "Call Driver",
  messageDriver: "Message Driver",
  
  // Payment
  payment: "Payment",
  mada: "Mada",
  visa: "Visa",
  mastercard: "Mastercard",
  applePay: "Apple Pay",
  finalPrice: "Final Price",
  discount: "Discount",
  paymentSuccess: "Payment Successful",
  
  // Orders
  current: "Current",
  completed: "Completed",
  cancelled: "Cancelled",
  date: "Date",
  tripType: "Trip Type",
  price: "Price",
  status: "Status",
  
  // Profile
  editProfile: "Edit Profile",
  tripHistory: "Trip History",
  paymentMethods: "Payment Methods",
  darkMode: "Dark Mode",
  logout: "Logout",
  
  // Common
  back: "Back",
  next: "Next",
  cancel: "Cancel",
  save: "Save",
  loading: "Loading...",
  error: "Error occurred",
  success: "Success"
};